import { create } from 'zustand';

export interface FilterChip {
  type: string;
  value: string;
  label: string;
}

interface FilterState {
  // Status filter (for dashboard tabs)
  activeStatus: string;
  setActiveStatus: (status: string) => void;

  // Filter chips (for secondary filters)
  activeChips: FilterChip[];
  addChip: (chip: FilterChip) => void;
  removeChip: (type: string, value: string) => void;
  clearAllChips: () => void;

  // Search
  searchQuery: string;
  setSearchQuery: (query: string) => void;

  // Date range
  dateRange: { from: string; to: string } | null;
  setDateRange: (range: { from: string; to: string } | null) => void;

  // Reset all
  resetFilters: () => void;
}

const initialState = {
  activeStatus: 'awaiting',
  activeChips: [] as FilterChip[],
  searchQuery: '',
  dateRange: null as { from: string; to: string } | null,
};

export const useFilterStore = create<FilterState>()((set) => ({
  ...initialState,

  setActiveStatus: (status) => set({ activeStatus: status }),

  addChip: (chip) =>
    set((state) => {
      // Don't add duplicate chips
      const exists = state.activeChips.find(
        (c) => c.type === chip.type && c.value === chip.value
      );
      if (exists) return state;
      return { activeChips: [...state.activeChips, chip] };
    }),

  removeChip: (type, value) =>
    set((state) => ({
      activeChips: state.activeChips.filter(
        (c) => !(c.type === type && c.value === value)
      ),
    })),

  clearAllChips: () => set({ activeChips: [] }),

  setSearchQuery: (query) => set({ searchQuery: query }),

  setDateRange: (range) => set({ dateRange: range }),

  resetFilters: () => set(initialState),
}));
